import React from 'react'
import ReactDOM from 'react-dom'
import AxSigning from './axsigning'
import { store } from '../../store' 

$.fn.axsigning = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(AxSigning, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-ax-signing]').axsigning();
});